// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const emptyObjectReturn = <T extends { [s: string]: any }>(
  obj: T
): T | undefined => {
  return Object.values(obj).every((field) => field === undefined)
    ? undefined
    : obj
}
